// Story 79 (RN34/DG-B10) — how much of a component the operator may type in the Components widget.
//
// Historically the cap was min(pending, available) and the controls went inert with available 0.
// With the technology's `generateComponents` flag on, Sun materializes whatever is missing at report
// time, so capping at the stock would make the very case the story enables unreachable: the operator
// could not even type the quantity. The only cap then is the PENDING amount (RN8) — `Available`
// keeps showing real stock and nothing warns the operator (P4).

const roundQty = (value) => {
  const num = Number(value)
  return Number.isFinite(num) ? Math.round(num * 100) / 100 : 0
}

export const computeMaxQuantity = ({
  pending = 0,
  available = 0,
  availableSecondUnit = 0,
  conversionFactor = 0,
  useSecondUnit = false,
  generateComponents = false
}) => {
  const pendingInUnit = useSecondUnit ? roundQty(pending * conversionFactor) : roundQty(pending)
  if (generateComponents) {
    return Math.max(0, pendingInUnit)
  }
  const stockInUnit = useSecondUnit ? (availableSecondUnit ?? 0) : (available ?? 0)
  return Math.max(0, Math.min(pendingInUnit, stockInUnit))
}

// Whether the current unit accepts decimals. The reference decides it as always; the flag only adds
// a defensive exception (DG-H3, S42 row 2): a non-fractionable reference should never carry a
// decimal pending, but if one arrives, flooring the cap to the whole unit below would leave the
// remainder impossible to report forever (the next attempt's cap would be 0). Sun rounds up and
// consumes the whole unit (S44), so the front must let the whole pending be typed.
export const allowsDecimalEntry = ({
  fractionable = false,
  unitary = false,
  useSecondUnit = false,
  generateComponents = false,
  max = 0
}) => {
  const acceptedByReference = useSecondUnit ? unitary !== true : fractionable === true
  return acceptedByReference || (generateComponents && !Number.isInteger(max))
}
